import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../core/constants/routes';

/**
 * Hook personnalisé pour gérer la navigation vers l'accueil
 * @returns {Object} - Fonctions de navigation vers l'accueil
 */
export const useHomeNavigation = () => {
  const navigate = useNavigate();

  // Fonction pour naviguer vers l'accueil (dashboard)
  const goToHome = useCallback(() => {
    navigate(ROUTES.DASHBOARD);
  }, [navigate]);

  // Fonction pour naviguer vers l'accueil avec remise à zéro de l'historique
  const goToHomeAndReplace = useCallback(() => {
    navigate(ROUTES.DASHBOARD, { replace: true });
  }, [navigate]);

  return {
    goToHome,
    goToHomeAndReplace
  };
}; 